import React, { useEffect, useState } from 'react'
import TopTitleBar from '../TopTitleBar'
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend, Cell } from 'recharts';

import API from '.././../../../ApiConfig'
import { GET_VERIFIER_BANNER, GET_VERIFIER_DASHBOARD } from '../../../../Utils/constant'
import cogoToast from 'cogo-toast-react-17-fix';
import Loader from '../../../../components/Loader'
import Tiles from '../../../../components/Verifier/Tiles'
import { Delay } from '../../../../Utils/helper';
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper';
import CustomCheckDropDown from '../../../../components/CustomCheckDropDown';
import CustomDropDown from '../../../../components/CustomDropDown';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCart } from '../../../../Utils/Redux/CartSlice';
import style from "../../../DashBoard/CompanyProfile.module.css"
import ReactPortalModal from '../../../../components/ReactPortalModal';
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']
export default function VerifierDash({ id }) {
    const dispatch = useDispatch()
    const User = useSelector(state => state.User)

    useEffect(() => {
        dispatch(fetchCart(User.user_id));
    }, [dispatch, User]);

    const [verifierData, setVerifierData] = useState([])
    const [chartData, setChartData] = useState([])
    const [chartKeys, setChartKeys] = useState([])
    const [loading, setLoading] = useState(false)
    const [GraphData, setGraphData] = useState([])
    const colors = {
        0: '#3535f6',
        1: '#ffb787'
    }
    const[no_of_days, setNoofDays]=useState({label:"Last 1 Week", value:7})
    const navigate = useNavigate();
    const [showBanner, setShowBanner]=useState(false)
    const [newBanner, setNewBanner]=useState("")
    const [showIssuerPopup, setShowIssuerPopup]=useState(true)
    const [issuersList, setIssuersList]=useState([{
        company_path:"/Walmart.png"
    },
{
    company_path:"/hp_partners_emp_07.png"
},
{
    company_path:"/Walmart.png"
},
{
    company_path:"/hp_partners_emp_07.png"
}
])
    const VerifierSteps = [
        {
            id: 1,
            text: "Select Verification from"
        },
        {
            id: 2,
            text: "Select Recipient"
        },
        {
            id: 3,
            text: "Recipient Details"
        }
    ]

    const TimeFilter = [
        { label: "Last 7 days", value: 7 },
        { label: "Last 30 days", value: 30 },
        { label: "Last 90 days", value: 90 }
    ]
    
   const getBanner=()=>{
        API.get(GET_VERIFIER_BANNER)
        .then(res=>{
            if(res.data.data.is_active){
                setShowBanner(true)
                setNewBanner(res.data.data.message)
            }
            
        })
        .catch(err=>{

            cogoToast.error(err.response.data.detail)
            
        })
    }

    useEffect(()=>{
        getBanner()

    },[])
    // const data = {
    //     "2024-05-22T12:20:31": [
    //         {
    //             "total_verifications": 1200,
    //             "pending": 100,
    //             "rejected": 100,
    //             "approved": 900,
    //             "form_name": "expirience letter"
    //         },
    //         {
    //             "total_verifications": 1000,
    //             "pending": 100,
    //             "rejected": 100,
    //             "approved": 900,
    //             "form_name": "relieving letter"
    //         }
    //     ],
    //     "2024-05-23T12:20:31": [
    //         {
    //             "total_verifications": 800,
    //             "pending": 100,
    //             "rejected": 100,
    //             "approved": 900,
    //             "form_name": "expirience letter"
    //         },
    //         {
    //             "total_verifications": 1100,
    //             "pending": 100,
    //             "rejected": 100,
    //             "approved": 900,
    //             "form_name": "relieving letter"
    //         }
    //     ]
    // }
    useEffect(() => {
        getDashData()
    }, [no_of_days])
    async function getDashData() {
        setLoading(true)
        await Delay()
        API.get(`${GET_VERIFIER_DASHBOARD}${id}?no_of_days=${no_of_days.value}`)
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    setGraphData(res.data.data.graph)
                    setVerifierData(res.data.data.general)
                }
            })
            .catch(err => {

                setLoading(false)
                cogoToast.error(err.response.data.detail);
            })

    }

    const barChartData = [
  { name: "Total Verification", value: GraphData.total_verifications },
  { name: "Pending Verification", value: GraphData.pending },
  { name: "Completed Verification", value: GraphData.completed }
]
    function responseAdapter(data) {
        let result = []
        let dataKeys = []
        Object.keys(data).map(item => {
            let Obj = {}
            // Obj.time = moment(item).format('DD-MM-YY')
            data[item].map(subItem => {
                // debugger
                // setVerifierData(subItem)
                Obj[subItem.form_name] = subItem.total_verifications
                if (!dataKeys.includes(subItem.form_name)) {
                    dataKeys.push(subItem.form_name)
                }
            })
            result.push(Obj)
        })
        setChartKeys(dataKeys)
        setChartData(result)
    }
    const handleTime = (e) => {
        setNoofDays(e)

    }
    const IssuersInfo=()=>{
        return(
            <div className={style.issuersContainer}>
                <div className={style.issuersList}>
                    {
                        issuersList.map((issuer,index)=>(
                            <div className={style.list}><img src={issuer.company_path} className={style.issuerImg}/></div>
                        ))
                    }
                </div>
            </div>
        )
    }
    return (
        <>
            <SlideUpWrapper direction="slide-down">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <TopTitleBar isChild >
                        <h2 className="topTitleBarText"> <span className="secondaryButton1">DashBoard</span></h2>
                    </TopTitleBar>
                    {/* <button className='btn btn-primary' style={{ width: "10%" }} onClick={() => navigate('../forms/qrReader')}> Verify using QR</button> */}
                </div>
                {loading ? <div className='shimmer' style={{ height: "10rem", borderRadius: "10px" }}></div> :
                    <div className="verifierTopcontainer">
                        <div className='verifierContainer'>
                            <div><h2 className='VerifierStepHeader'>Request your verification</h2></div>
                            <div className='heading'>How it works</div>
                            <div className='StepMainContainer'>
                                {VerifierSteps.map((i, index) =>
                                (<div className='StepContainer' key={index}>
                                    <div className='VerifierStepsContainer'><span className='VerifierSteps'>{i.id}</span>
                                        <span className='VerifierStepcontent'> {i.text} </span></div>
                                    {i.id == 3 ? null :
                                        <div style={{ textAlign: "center" }}><img src='chevron-right-gray.svg' alt='chevronRightgray.svg' className='right-icon' /></div>}
                                </div>)
                                )}
                            </div>
                        </div>
                        <div>
                            <button className='btn btn-primary' style={{ width: "100%" }} onClick={() => navigate(User.category=="GENERAL"?'/dashboard/forms/selectForms':'/dashboard/emp/search')}>+ Request Verification</button>
                        </div>

                    </div>}
                    {showBanner&&
                    <div dangerouslySetInnerHTML={{ __html: newBanner }}>
                        {/* <h2>
                        Raise an Appeal
                        </h2>
                        <p style={{fontSize:"16px"}}>To raise an appeal, please send an email to authnumber-support@authbridge.com with:</p>
                        <ul>
                            <li style={{margin:"10px 0px"}}>The details provided by us, and</li>
                            <li>The specific details for which you are raising the appeal, along with proper supporting documents.</li>
                        </ul> */}
                    </div>}
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                        <div>
                <div style={{ display: 'flex', gap: '1rem', flexWrap: ' wrap', margin: "4rem 0rem" }}>
                    <Tiles title={"Total Requests"} value={verifierData?.total_verifications} total={verifierData?.total_verifications} color={'#020D1730'} linkto={User.category=="GENERAL"?'/dashboard/forms/myRequests':'/dashboard/emp/requests'} />
                    <Tiles title={"Verification Pending"} value={verifierData?.pending} total={verifierData?.total_verifications} color={'#020D1730'} linkto={User.category=="GENERAL"?'/dashboard/forms/myRequests':'/dashboard/emp/requests'} />
                    <Tiles title={"Verification Completed"} value={verifierData?.completed} total={verifierData?.total_verifications} color={'#020D1730'} linkto={User.category=="GENERAL"?'/dashboard/forms/myRequests':'/dashboard/emp/requests'} />
                    {/* <Tiles title={"Requests Sent"} value={verifierData.rejected} linkto={'request-sent'}/> */}
                </div>
                </div>
                <div>
                <button className='btn btn-primary' style={{backgroundColor:"gray", fontSize:"18px"}} onClick={()=>navigate("/dashboard/Help")}>
                        View Tutorial

                    </button>
                </div>
                </div>


                {loading ? <div className="shimmer" style={{ width: '600px', height: '300px' }}></div> :
                    <>
                        <div style={{ width: "70%", padding: "0px 45px" }}>
                            {/* <div className='heading' style={{ width: "25%" }}>No. of Verifications requests.</div> */}
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
                                <div className='VerifierDropdown'>
                                    {TimeFilter.map((item, index)=>(
                                        <div key={index}>
                                            <div className={`${style.noOfDays} ${no_of_days.value==item.value? style.selected:null}`} onClick={()=>handleTime(item)}>{item.label}</div>
                                        </div>
                                    ))}
                                    {/* <CustomDropDown list={TimeFilter} selectedOption={no_of_days.label} onSelect={e => handleTime(e)} /> */}
                                </div>
                                {/* <div>
                                    <div className="export-btn">
                                        <img src='file-export-outline.svg' alt='file-export-outline.svg' className='export-icon' />
                                        <span>Export</span>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className='bar-chart-wrapper'>
                           <BarChart width={600} height={300} data={barChartData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip />
                                <Bar dataKey="value" barSize={20}>
                                    {barChartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Bar>
                            </BarChart>
                        </div>
                    </>
                }
                {/* <ReactPortalModal title={"Introducing our new Issuers"} isOpen={showIssuerPopup} onClose={()=>setShowIssuerPopup(false)} width="500px">
                    <IssuersInfo/>
                </ReactPortalModal> */}

            </SlideUpWrapper>
        </>
    )
}
